import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { Fragment } from 'react';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

function TipCen(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo , handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{  
                    document.title = getTitle(confPantalla.config.trad, confPantalla.tipcen.title);                                     
                    if( respuesta == 1 ){
                        saveTieneNivel(true);    
                        saveEstadoFormPrin(confPantalla.tipcen.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.tipcen.hijo.estadoform);                        
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.tipcen.padre.urls);
                                saveFormularioPrin(confPantalla.tipcen.padre.modelform);
                                saveFormularioHijo(confPantalla.tipcen.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.tipcen.padre.urls, confPantalla.tipcen.hijo.urls, confPantalla.tipcen.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);    
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
 

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.tipcen.section.titulo } icono={ confPantalla.tipcen.section.icono } col={ confPantalla.tipcen.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.tipcen.section.wiki } >
                            <Formulario 
                                        estadoForm= { estadoFormPrin }
                                        loading=    { loadReg ? true : false }
                                        btnNew={ confPantalla.tipcen.padre.btnform.new }
                                        btnSave={ confPantalla.tipcen.padre.btnform.save }
                                        btnSaveAndNew={ confPantalla.tipcen.padre.btnform.saveandnew }
                                        btnDelete={ confPantalla.tipcen.padre.btnform.delete }
                                        btnClone={ confPantalla.tipcen.padre.btnform.clone }
                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.tipcen.padre.urls, confPantalla.tipcen.padre.modelform, confPantalla.tipcen.padre.tabla, confPantalla.tipcen.hijo.modelform, confPantalla.tipcen.title) }
                                        formulario = { formularioPrin } 
                                        resetForm = { e => resetFormPrin(confPantalla.tipcen.padre.modelform, true, confPantalla.tipcen.padre.tabla) } 
                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.tipcen.padre.urls, confPantalla.tipcen.padre.modelform, confPantalla.tipcen.padre.tabla, confPantalla.tipcen.title) }
                            >         
                            <h4>{ formularioPrin.ruta }</h4>   
                                <FormRow clases="" >
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.pad  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.tipcen.padre.controles.pad.id }    
                                        name=        { confPantalla.tipcen.padre.controles.pad.name }   
                                        label=       { confPantalla.tipcen.padre.controles.pad.label }    
                                        placeholder= { confPantalla.tipcen.padre.controles.pad.placeholder }
                                        col=         { confPantalla.tipcen.padre.controles.pad.col } 
                                        isClearable= { confPantalla.tipcen.padre.controles.pad.isclearable }
                                        isSearchable={ confPantalla.tipcen.padre.controles.pad.issearchable }
                                        dataType=    { confPantalla.tipcen.padre.controles.pad.datatype }
                                        data=        { confPantalla.tipcen.padre.controles.pad.data }
                                        required=    { confPantalla.tipcen.padre.controles.pad.required } 
                                        disabled=    { confPantalla.tipcen.padre.controles.pad.disabled }
                                        readOnly =   { confPantalla.tipcen.padre.controles.pad.readonly }
                                        disablethisid={confPantalla.tipcen.padre.controles.pad.disablethisid}
                                        formulario = { formularioPrin } 
                                        change=      { handleSelectFormPrin }                                                    
                                    />                                    
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.tipcen.padre.controles.nom.id }   
                                        type=       { confPantalla.tipcen.padre.controles.nom.type }  
                                        name=       { confPantalla.tipcen.padre.controles.nom.name }   
                                        label=      { confPantalla.tipcen.padre.controles.nom.label }                                                       
                                        placeholder={ confPantalla.tipcen.padre.controles.nom.placeholder }    
                                        col=        { confPantalla.tipcen.padre.controles.nom.col } 
                                        required=   { confPantalla.tipcen.padre.controles.nom.required }
                                        readonly=   { confPantalla.tipcen.padre.controles.nom.readonly }                                                
                                        disabled=   { confPantalla.tipcen.padre.controles.nom.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom_en }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.tipcen.padre.controles.nom_en.id }   
                                        type=       { confPantalla.tipcen.padre.controles.nom_en.type }  
                                        name=       { confPantalla.tipcen.padre.controles.nom_en.name }   
                                        label=      { confPantalla.tipcen.padre.controles.nom_en.label }                                                       
                                        placeholder={ confPantalla.tipcen.padre.controles.nom_en.placeholder }    
                                        col=        { confPantalla.tipcen.padre.controles.nom_en.col } 
                                        required=   { confPantalla.tipcen.padre.controles.nom_en.required }
                                        readonly=   { confPantalla.tipcen.padre.controles.nom_en.readonly }                                                
                                        disabled=   { confPantalla.tipcen.padre.controles.nom_en.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                </FormRow>
                                <FormRow clases="">
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.tipo  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.tipcen.padre.controles.tipo.id }    
                                        name=        { confPantalla.tipcen.padre.controles.tipo.name }   
                                        label=       { confPantalla.tipcen.padre.controles.tipo.label }    
                                        placeholder= { confPantalla.tipcen.padre.controles.tipo.placeholder }
                                        col=         { confPantalla.tipcen.padre.controles.tipo.col } 
                                        isClearable= { confPantalla.tipcen.padre.controles.tipo.isclearable }
                                        isSearchable={ confPantalla.tipcen.padre.controles.tipo.issearchable }
                                        dataType=    { confPantalla.tipcen.padre.controles.tipo.datatype }
                                        data=        { confPantalla.tipcen.padre.controles.tipo.data }
                                        required=    { confPantalla.tipcen.padre.controles.tipo.required } 
                                        disabled=    { confPantalla.tipcen.padre.controles.tipo.disabled }
                                        readOnly =   { confPantalla.tipcen.padre.controles.tipo.readonly }
                                        disablethisid={confPantalla.tipcen.padre.controles.tipo.disablethisid}
                                        formulario = { formularioPrin } 
                                        change=      { handleSelectFormPrin }                                                    
                                    /> 
                                </FormRow>                            
                            </Formulario>
                            <MiDataTable 
                                formulario={formularioPrin}
                                estadoForm= { estadoFormPrin }
                                id={"tipcen"}
                                columnas={confPantalla.tipcen.padre.datatable.columns}
                                data={registrosPrin}
                                buttons={confPantalla.tipcen.padre.datatable.buttons}
                                ordering={confPantalla.tipcen.padre.datatable.ordering}
                                order={confPantalla.tipcen.padre.datatable.order}
                                searching={confPantalla.tipcen.padre.datatable.searching}
                                paging={confPantalla.tipcen.padre.datatable.paging}
                                select={confPantalla.tipcen.padre.datatable.select}
                                pagelength={confPantalla.tipcen.padre.datatable.pagelength}
                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.tipcen.padre.urls, confPantalla.tipcen.hijo.urls, confPantalla.tipcen.padreshijos, confPantalla.tipcen.hijo.modelform, confPantalla.tipcen.padre.tabla) }
                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.tipcen.padre.urls, confPantalla.tipcen.padre.modelform, confPantalla.tipcen.padre.tabla, confPantalla.tipcen.title) }
                                saveLoadingTable={ saveLoadingTable }
                                loadingTable={loadingTable}
                                columnactions={confPantalla.tipcen.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                                             
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default TipCen